export default __webpack_public_path__ + "static/media/roundButton_inactive.3399cff5.svg";